import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect,useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from '@material-ui/core';

const PhotoGalleryMaster = () => {
  const [editMode, setEditMode] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
  const [startIndex, setStartIndex] = useState(0);
  const [ searchQuery,setSearchQuery] = useState('');
  const history = useHistory();
  const [photoList, setPhotoList] = useState([]);
  const [photoid, setphotoid] = useState('');
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState({});
  const [profile, setProfile] = useState(null);
  const profileInputRef = useRef(null);
  const [profileName, setProfileName] = useState("");


  useEffect(() => {
    fetchPhotoGalleryMaster();
}, [currentPage]);

const fetchPhotoGalleryMaster = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
      const response = await axios.get(`${var_api}/api/photo_gallery/get`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      setPhotoList(response.data);
      
      setIsLogin(false);
  } catch (error) {
    setPhotoList([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }
};


const validateForm = () => {
  const newErrors = {};

  if (!profile && !profileName) newErrors.image = 'Image is required';
  if (!description) newErrors.description = 'Description is required';

  return newErrors;
};


const createphotogallery = async () => {
    const newErrors = validateForm();
    setErrors(newErrors); // Update the state with validation errors
  
    // If there are errors, don't proceed with the form submission
    if (Object.keys(newErrors).length > 0) {
      return;
    }
  
    const token = localStorage.getItem('token');
    setIsLogin(true);
  
    // Create a JSON object instead of FormData
    const formData = new FormData();
    formData.append('image', profile); // Assuming profile holds the file
    formData.append('description', description);
    formData.append('user_id', 1);
  
    try {
      const response = await axios.post(`${var_api}/api/photo_gallery/post`, formData, {
        headers: {
            'Authorization': `${token}`,
            'Content-Type': 'multipart/form-data'
          }
      });
  
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Photo Created Successfully',
          confirmButtonColor: '#007500',
        });
        console.log('Photo created successfully!');
      }
      fetchPhotoGalleryMaster();
      resetForm();
    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    } finally {
      setIsLogin(false);
    }
  };
  

  const updatePhotoMaster = async () => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    
    const newErrors = validateForm();
    setErrors(newErrors); // Update the state with validation errors
  
    // If there are errors, don't proceed with the form submission
    if (Object.keys(newErrors).length > 0) {
      return;
    }
  
    // Create a new FormData object and append fields
    const formData = new FormData();
    formData.append('description', description);
    if (profile instanceof File) {
        formData.append('image', profile); // Send the new file
      } else {
        formData.append('image', profileName); // Send the existing profile name
      }
  
    try {
      const response = await axios.put(`${var_api}/api/photo_gallery/put/${photoid}`, formData, {
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
  
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Photo Updated Successfully',
          confirmButtonColor: '#007500',
        });
        console.log('Photo updated successfully!');
      }
      fetchPhotoGalleryMaster();
      resetForm();
    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    } finally {
      setIsLogin(false);
    }
  };
  

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setProfile(file);
    setProfileName(file ? file.name : ""); // Update file name state for display
};

  const resetForm = () => {
    setProfile(null);
    setDescription('');
    setEditMode(false); // Assuming you set profile file
    if (profileInputRef.current) {
        profileInputRef.current.value = '';  // Clear file input
      }
      setProfileName('')
};


const handleEdit = (photo) => {
    setEditMode(true);
    setphotoid(photo.id);
    setDescription(photo.description);
    setProfileName(photo.image);
  };

  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
  };
  
  // Filter tax before applying pagination
  const filteredEmployees = Array.isArray(photoList) && photoList.filter(photo => {
    const searchLower = searchQuery.toLowerCase();
    return (
      (photo.description && photo.description.toString().toLowerCase().includes(searchLower))
    );
  });
  
  // Apply pagination to the filtered list
  const paginatedFilteredEmployees = filteredEmployees.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Update current page
  };

    return(
        <>
        {isLogin && <Loader />}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       PHOTO GALLERY MASTER
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
         <div style={{margin:"auto",padding:"20px"}}>
             <Row>
             <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
             <Card style={{ border: "none", maxWidth: "28rem", padding: "15px 27px", margin: "auto", height: "auto", borderRadius: "20px", boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}>
            <Card.Body>
                <h5 style={{ textAlign: "center", color: "rgb(89, 128, 71)", fontWeight: "bold" }}>{editMode ? 'Edit Photo Gallery' : 'Create Photo Gallery'}</h5>
                <Form onSubmit={(e) => e.preventDefault()}>
                <Form.Group controlId="formBasicProfile" className="mt-3">
                        <Form.Label>Upload Photo</Form.Label>
                        <Form.Control
                            type="file"
                            placeholder="Select File"
                            name="profile"
                            onChange={handleFileChange}
                            ref={profileInputRef}
                        />
                        {profileName && <small className="text-muted">Selected File: {profileName}</small>}
                    </Form.Group>

                    <Form.Group controlId="formBasicEmail" className="mt-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Description"
                            name="description"
                            value={description}
                            onChange={(e) =>  setDescription(e.target.value)}
                            required
                        />
                        {errors.description && <p style={{ color: 'red' }}>{errors.description}</p>}
                    </Form.Group>

                     <Button variant="primary" type="button" className="mt-3" 
                      style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
                      onClick={createphotogallery} hidden={editMode}  // This will hide the Submit button when editMode is true
                        >
                    Submit
                    </Button>{" "}
                    <Button variant="primary" type="button" className="mt-3"
                     style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
                     onClick={() => updatePhotoMaster()} hidden={!editMode}  // This will hide the Update button when editMode is false
                    >
                    Update
                    </Button>{" "}

                    <Button variant="danger" type="button" className="mt-3" onClick={resetForm}>
                        Reset
                    </Button>
                </Form>
            </Card.Body>
        </Card>
</Col>
                <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none", maxWidth:"62rem", padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
                 <h5 style={{color:"rgb(89, 128, 71)", fontWeight:"bold"}}>Photo Gallery List  <span style={{float:"right", fontSize:"17px", color:"black", fontWeight:"bold"}}><Form.Control type="text" placeholder="Search..."  onChange={handleSearchInput}/></span> </h5>  

        <Table responsive className="mt-3">
          <thead>
            <tr>
              <th>S.No</th> 
              <th>Gallery Image</th>
              <th>Description</th>
              <th>Action</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
  {paginatedFilteredEmployees.length > 0 ? (
    paginatedFilteredEmployees.map((photo, index) => (
      <tr key={photo.id}>
        <td>{startIndex + index + 1}</td>
        <td>
          <img src={`${var_api}/${photo.image}`} alt="No Image" width="50px" height="50px" />
        </td>
        <td>{photo.description}</td>
        <td>
          <Button variant="primary" className="m-1" onClick={() => handleEdit(photo)}>
            <i className="bi bi-pencil-square"></i>
          </Button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="7" className="text-center">No data available</td>
    </tr>
  )}
</tbody>
</Table>
<Pagination
  activePage={currentPage}
  itemsCountPerPage={itemsPerPage}
  totalItemsCount={filteredEmployees.length} // Update total count to reflect filtered data
  pageRangeDisplayed={5}
  onChange={handlePageChange}
  itemClass="page-item"
  linkClass="page-link"
  innerClass="pagination justify-content-end"
  activeClass="active-pagination"
/>
      </Card>
                </Col>
            </Row>
        </div>
        </>
    )
}

export default PhotoGalleryMaster;